import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';

import Navbar from './Navbar';
import { Container, Row } from "react-bootstrap";

import './css/VenThero.css';

function VenThero() {
    return (

        <div className="grid gap-0 row-gap-3">

            <div className="p-5">
                <Navbar />
            </div>

            <div className="p-5">
                <Container className="page">
                    <Row>
                        <div className="page-title">
                            <img className="img-fluid float-left img-responsive" src={require('./images/VenSThero.jpg')} align="left" alt="VenThero" />
                            <p>Chief Sanganayake of Australia – Asgiriya Chapter</p>
                            <p>Wimalakeerthi Sri Devananda</p>
                            <p>and</p>
                            <p>Chief Incumbent of Dhammadeepa Meditation Centre</p>
                            <p>Honourable Venerable Akaravita Sangananda Thero, MA</p>
                        </div>
                    </Row>

                    <Row></Row>

                    <Row className="page-content p-5">
                        <p>The unique identity of the Sinhalese is their virtuous behaviour that is nurtured by the Buddhist culture through long civilisation.
                            It clearly shows us that the cultural disciplines and values have helped us to enlighten and brighten our lives irrespective of the place we live in, in this world.
                            Especially in a multicultural country like Australia, exhibiting our cultural values will pave the way to disseminate the message of the pride of our heritage to the world.
                        </p>
                        <p>
                            The Dhammadeepa meditation centre commenced in 1994 at Henley street and shifted to Hemmings street, Dandenong in 1995.
                            Even though we live thousands of miles away from our motherland, I have the great pleasure of praising the efforts of the Sinhalese community,
                            to build temples and live according to the thoughts of the religion and the guidance of our religious leaders.
                        </p>
                        <p>
                            Since the inception of the centre, it has been able to continually conduct the daily rituals, mediation classes on Saturdays and to conduct the “Dhamma Pasal” on Sundays.
                            In addition, annual “Katina Pinkama”, “Vesak lanterns” for the Vesak Festival and “Bakhthi Gee” are held with the participation and the assistance of all Melbournians.
                        </p>
                        <p>තෙරුවන් සරණයිි</p>
                        <p>May the Noble Triple Gems Protect You All</p>
                    </Row>
                </Container>
            </div>
        </div>
    )
}
export default VenThero;
